import { NgModule } from '@angular/core';
import { PanelsService } from './panels.service';
import { PanelsBackend } from './panels.backend';

@NgModule({
  providers: [PanelsService, PanelsBackend],
})
export class PanelsModule {}
